// extracted by mini-css-extract-plugin
export default {"maindiv":"Banner_maindiv__NQRRo","div3":"Banner_div3__diAfs","div31":"Banner_div31__7HA2z","div32":"Banner_div32__QlaXU"};